<template>
    <div class="typeArea box">
      <div class="top">
          <div class="top-left">
              <div>药物发现、化学品物理危险性鉴定与分类管理、农药产品质量检测、保健食品检验与评价、消毒产品检验等多领域服务。</div>
              <div @click="$router.push('/aboutUs/contactUs')">
                  <img src="@/assets/images/image57.png" alt="">
                  <span>联系我们</span>
              </div>
          </div>
          <div class="top-right">
              <defaultImg class="banner" :src="require('@/assets/images/image74.png')"></defaultImg>
          </div>
      </div>
      <div class="bottom">
            <tabContent class="mg-top80" :dataList="dataList"></tabContent>
      </div>
    </div>
  </template>
  
  <script>
  import tabContent from '@/views/ourService/components/tabContent'
  export default {
    name: 'otherService',
    components:{tabContent},
    data () {
      return {
            activeName: 'first',
            dataList:{
                total:5,
                list:[{
                    src: require('@/assets/images/otherService/image1.png'),
                    title: "药物发现"
                },{
                    src: require('@/assets/images/otherService/image2.png'),
                    title: "化学品物理危险性鉴定与分类管理"
                },{
                    src: require('@/assets/images/otherService/image3.png'),
                    title: "农药产品质量检测"
                },{
                    src: require('@/assets/images/otherService/image4.png'),
                    title: "保健食品检验与评价"
                },{
                    src: require('@/assets/images/otherService/image5.png'),
                    title: "消毒产品检验"
                }]
            },
      }
    },
    methods: {},
  }
  </script> 
  
  <style lang='less' scoped>
  
  </style>
  